import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import { arquivamentoTipoEmum } from '../../../../arquivamento.utils';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

export default function ModalDetalhes (props) {
  const intl = useIntl()
  const [modalAberto, setModalAberto] = useState(false);
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const dispatch = useDispatch();

  useEffect(() => {
    setModalAberto(props.showModalDetalhes);
    dispatch(commonActions.showModal(props.showModalDetalhes));
  }, [props.showModalDetalhes]);

  function toggle () {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-lg'
          backdrop={backdrop}
          keyboard={keyboard}
          centered
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            <div>{`${intl.formatMessage({id: 'general.materialArchiving.details'})} ${props.itemSelecionado.numeroMaterial}`}</div>
          </ModalHeader>
          {props.itemSelecionado && (
            <ModalBody>
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.exam" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.exame}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.report" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.laudo}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.medicalRecord" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.prontuario}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.completionDate" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.dataFinalLaudo}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.patient" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.paciente}
                    />
                  </FormGroup>
                </Col>

                <Col lg={3}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.archiving" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.dataArquivamento}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg={9}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.technician" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.nomeTecnico}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.material" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.descricaoMaterial}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.location" />:</Label>
                    <Input
                      type='textarea'
                      rows={3}
                      disabled={true}
                      value={props.itemSelecionado.localizacaoArquivamento}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
          )}
          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="general.materialArchiving.close" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/modais/Detalhes/index.js